<template>
    <div class="users mx-3 pb-0 pt-2">
        <div v-for="(user, index) in users" :key="user.id" class="user-item">
            <v-avatar size="47" class="user-avatar" :class="`user-avatar-${index + 1}`">
                <img :src="user.profilePic" alt="Profile Pic" @error="getDefaultImage">
            </v-avatar>
            <div class="top-user pointer d-flex align-center bg-user" :class="`bg-user-${index + 1}`">
                <div :class="`user-top-${index + 1}`"></div>
                <div class="user-position" :class="`user-position-${index + 1}`">
                    <strong>{{ index + 1 }}</strong>
                </div>

                <div class="user-info d-flex align-center justify-space-between" :class="`user-${index + 1}`">
                    <div class="pl-10">
                        <span class="fs--14 fw--600">{{ user.user }}</span>
                    </div>
                    <div class="bits-info pr-4">
                        <div class="d-flex align-center justify-center">
                            <img :src="getIcon(user.value)" width="15" class="mr-2" alt="Bits" />
                            <span class="fs--13 fw--600">{{ user.value.toLocaleString() }}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { getBitIcon } from '@/utils/utils';
export default {
    name: 'TopUsers',
    props: {
        users: Array
    },
    setup() {
        const getIcon = (value) => {
            return getBitIcon(value);
        }

        const getDefaultImage = (e) => {
            e.target.src = require('@/assets/images/profile.png');
        }

        return { getIcon, getDefaultImage }
    }
}
</script>

<style lang="scss" scoped>
.user-item {
    position: relative;

    .user-avatar {
        position: absolute;
        left: 28px;
        top: -3px;
        border: 2px solid;
        z-index: 9;
        filter: drop-shadow(0px 7px 4.5px rgba(32, 15, 72, 0.23));
    }

    .user-avatar-1 {
        background: #f9e869;
        border-color: #f9e869;
    }

    .user-avatar-2 {
        border-color: #74CCF4;
        background: #74CCF4;
    }

    .user-avatar-3 {
        border-color: #CA9679;
        background: #CA9679;
    }
}

.bg-user {
    border-radius: 3px;
    margin-bottom: 10px;
}

.top-user {
    width: 100%;
    height: 41px;
    border-radius: 3px;
    position: relative;
    clip-path: polygon(0% 0%, 100% 0%, 98.5% 50%, 100% 100%, 0% 100%);

    .user-info {
        width: 100%;
    }

    .bits-info img {
        filter: drop-shadow(0px 2px 1.5px rgba(0, 0, 0, 0.48));
    }

    img.position-badge {
        position: absolute;
        top: -3px;
        left: -8px;
        z-index: 3;
        width: 20px;
    }
}

.user-1 .user-avatar {
    border-color: #f9e869;
}

.user-position {
    width: 47px;
    z-index: 1;

    strong {
        font-size: 18px;
        font-weight: 700;
    }
}

.user-position {
    height: 41px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    border-radius: 4px 0 0 4px;
    z-index: 1;
}

.bg-user-1 {
    box-shadow: inset 0 0 4px 1px rgba(255, 240, 142, 0.84);
    background-color: #c45a2c;

    span {
        color: #ffe869;
    }
}

.bg-user-2 {
    box-shadow: inset 0 0 4px 1px rgba(142, 255, 240, 0.84);
    background-color: #2576a9;

    span {
        color: #c0dfff;
    }
}

.bg-user-3 {
    box-shadow: inset 0 0 4px 1px rgba(249, 199, 181, 0.84);
    background-color: #885a48;

    span {
        color: #fdc7b3;
    }

    .user-avatar {
        border-color: #CA9679;
    }
}

.user-position-1 {
    background: #b72607;
    border: 1px solid #db3209;

    strong {
        color: #ffe869;
    }
}

.user-position-2 {
    background: #0a3890;
    border: 1px solid #0b5dd0;

    strong {
        color: #b7dafa;
    }
}

.user-position-3 {
    background: #542c20;
    border: 1px solid #883c29;

    strong {
        color: #e0a38c;
    }
}
</style>